/**
 * Root App: providers (React Query + MFA step-up + Sonner toaster) e
 * routing.
 *
 * NOTA: `MfaStepUpProvider` deve stare DENTRO `BrowserRouter` (montato in
 * AppRouter) perché internamente apre un `MfaModal` (Radix Portal) che
 * non dipende dal router, ma anche per coerenza visiva. Lo montiamo qui
 * a livello App (sopra il router) perché il modal usa Portal e non
 * necessita del contesto router.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { MfaStepUpProvider } from './hooks/useMfaStepUp';
import { AppRouter } from './routing/AppRouter';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MfaStepUpProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </MfaStepUpProvider>
    </QueryClientProvider>
  );
}
